import { handleSubmit } from "../service/handleSubmit";

/**
 * Orders the list of modules by using the provided `handleSubmit` function.
 * 
 * @param {Array} modules - The list of modules to be processed and ordered.
 * @param {Function} handleSubmit - A function that processes and orders the modules.
 *                                   This function should return the ordered list of modules.
 * 
 * @returns {Array} - The ordered list of modules. If the `handleSubmit` function fails or returns an empty list,
 *                    the original list of modules is returned.
 * 
 * @throws {Error} - Logs an error message if there is an issue with ordering the modules.
 */
export const orderModules = async (modules) => {
  try {
    const orderedModules = await handleSubmit(modules);
    return orderedModules.length > 0 ? orderedModules : modules;
  } catch (error) {
    console.error('Error ordering modules:', error);
    return modules;
  }
};
